import { CompanyCard } from "../CompanyCard";
import { CompaniesListingStyled, ListStyled } from "./styled";
import { useAllSharedProfiles } from "newui/features/Auth/hooks/useAllSharedProfiles";
import SkeletonBase from "newui/components/Skeleton";

export const SharedProfileList: React.FC = ({
}) => {
  const { data, isLoading } = useAllSharedProfiles();
  const sharedProfiles = data?.data?.data || [];

  if (isLoading) {
    return <SkeletonBase />;
  }

  return (
    <CompaniesListingStyled>
      {sharedProfiles.length > 0 ? (
        <ListStyled className="flex flex-wrap gap-6">
          {sharedProfiles.map(({ company }) =>
            company ? (
              <CompanyCard
                company={company}
                key={company.id}
                className="grow-1 min-w-[300px] shrink-0"
                linkNewTab={true}
                isAdminMode={false}
              />
            ) : null
          )}
        </ListStyled>
      ) : (
        <div className="message">No Shared Profiles</div>
      )}
    </CompaniesListingStyled>
  );
};